export default __webpack_public_path__ + "static/media/group-option-moustache-unselected.29eeec11.svg";